import React from 'react';
import {  Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Fi from 'react-icons/fi';

import CustomerForm from '../form';

const initialState = {
  isUpdate: false,
};

const Action = ({ data }) => {
 const [{ isUpdate }, setState] =
    React.useState(initialState);

  const $handleClose = () => {
    setState((prevState) => ({
      ...prevState,
      isUpdate: false,
    }));
  };

  return (
    <>
      <OverlayTrigger
        placement="bottom"
        overlay={<Tooltip id={`tooltip-top`}>Perbaharui</Tooltip>}
      >
        <button
          className="btn btn-primary px-2"
          onClick={() =>
            setState((prevState) => ({ ...prevState, isUpdate: true }))
          }
        >
          <Fi.FiEdit />
        </button>
      </OverlayTrigger>


      <Modal
        show={isUpdate}
        onHide={$handleClose}
        backdrop="static"
        centered
        size="lg"
        enforceFocus={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>Perbaharui Customer</Modal.Title>
        </Modal.Header>
        <CustomerForm onClose={$handleClose} data={data} />
      </Modal>
    </>

  );
};

export default Action;
